/**
 * @ngdoc directive
 * @name drvContactFromEntitySelector
 * 
 * @description
 * Used for selecting what entities the contact using object (SMS etc.) will be associated with to perform a send operation.
 */

(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvContactFromEntitySelector', drvContactFromEntitySelector);

    drvContactFromEntitySelector.$inject = [];

    function drvContactFromEntitySelector() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: drvContactFromEntitySelectorCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                multiMode: '<',
                contacts: '=',
                entityTemplate: '<'
            },
            template:
                '<div ng-if="drvCtrl.multiMode">' +
                '   <drv-entity-linked-many-input ng-model="drvCtrl.internalValue" field="drvCtrl.fieldDetails" entity-template="drvCtrl.entityTemplate"></drv-entity-linked-many-input>' +
                '</div>' +
                '<div ng-if="!drvCtrl.multiMode">' +
                '   <drv-entity-linked-single ng-model="drvCtrl.internalValue" field="drvCtrl.fieldDetails" flex="90"></drv-entity-linked-single>' +
                '</div>'
        };

        drvContactFromEntitySelectorCtrl.$inject = ['$scope'];

        return directive;

        function drvContactFromEntitySelectorCtrl($scope) {
            /* jshint validthis:true */
            var drvCtrl = this;

            activate();

            function activate() {
                updateInternalValue();
                drvCtrl.fieldDetails = { EntityTemplateId: drvCtrl.entityTemplate.Id, DisableFullClear: true };

                if (drvCtrl.multiMode) {
                    drvCtrl.fieldDetails.Name = drvCtrl.entityTemplate.PluralName;
                } else {
                    drvCtrl.fieldDetails.Name = drvCtrl.entityTemplate.Name;
                }

                $scope.$watch('drvCtrl.internalValue', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        updateContacts();
                    }
                }, true);

                $scope.$watch('drvCtrl.contacts', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        updateInternalValue();
                    }
                }, true);

                function updateInternalValue() {
                    var newInternalValue;

                    if (drvCtrl.multiMode) {
                        newInternalValue = drvCtrl.contacts;
                    } else {
                        if (!_.isNil(drvCtrl.contacts[0])) {
                            newInternalValue = drvCtrl.contacts[0];
                        }
                    }

                    if (!angular.equals(newInternalValue, drvCtrl.internalValue)) {
                        drvCtrl.internalValue = newInternalValue;
                    }
                }

                function updateContacts() {
                    var newContacts = [];

                    if (drvCtrl.multiMode) {
                        newContacts = drvCtrl.internalValue;
                    } else {
                        if (!_.isNil(drvCtrl.internalValue)) {
                            newContacts.push(drvCtrl.internalValue);
                        }
                    }

                    if (!angular.equals(newContacts, drvCtrl.Contacts)) {
                        drvCtrl.contacts = newContacts;
                    }
                }
            }
        }
    }
})();